<input class="input-color" type="color" (change)="HandlerChange($event)"
[disabled]="data.Reading === 1 ? true : false"
>